export interface SalesInvoiceQualitySummaryReport {
  productGroup: string;
  commodityCode: string;
  quantity: number;
  grossKgs: number;
  nettKgs: number;
}
